/**
 * Created by brunopoeta on 19/06/17.
 */

import angular from 'angular';

// Controllers
import CalendarController from './controllers/calendar.controller';

// Directives
import ToolbarDirective from '../../directives/toolbar.directive';

// Filters
import SortFilter from '../../filters/sort.filter';

angular
    .module('calendar', [])
    .config(['$compileProvider', function ($compileProvider) {
    	$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);
    }])
    .controller('CalendarController', ['$http', CalendarController])
    .directive('toolbar', ToolbarDirective)
    .filter('sort', SortFilter);

angular
    .element(() => {
        angular.bootstrap(document, ['calendar']);
    });
